module.exports = __webpack_public_path__ + "static/img/a0e0a1e32da7d5be4b5a749234406fe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_disable_04.png
// module id = sb04
// module chunks = 1